import { render } from "./BgHomeComponent.vue?vue&type=template&id=3c11f02a"
import script from "./BgHomeComponent.vue?vue&type=script&lang=js"
export * from "./BgHomeComponent.vue?vue&type=script&lang=js"

import "./BgHomeComponent.vue?vue&type=style&index=0&id=3c11f02a&lang=scss"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__